import CustomError from "./CustomError";

export default class NetworkError extends CustomError {}
